import IconButton from "@material-ui/core/IconButton";

// @material-ui/icons components
import GetAppIcon from "@material-ui/icons/GetApp";
import FileCopyIcon from "@material-ui/icons/FileCopy";

// Karsten
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import PhoneText from "components/_refactor/text/phone";
import EmailText from "components/_refactor/text/email";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import MaskAndValid from "utils/maskAndValid";
import { Tooltip } from "@material-ui/core";
import { FileCopy } from "@mui/icons-material";

const getFileInvoice = async (isOD, tipo, chave) => {
  return await Api.get(
    tipo,
    "invoice",
    (isOD ? "?numeroOd=" : "?chaveNf=") + chave,
    false
  )
    .then((value) => {
      const url =
        "data:application/octet-stream;base64," + value.Result.FileBase64;
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.target = "_blank";
      downloadLink.download = chave + "." + tipo;
      downloadLink.click();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const downloadPDF = (cell, row) => {
  return (
    <div>
      {row.PdfNoS3 ? (
        <IconButtonLoader
          title="Download PDF"
          size="small"
          onClick={(e) => getFileInvoice("pdf", row.ChaveNf, e)}
          icon={<GetAppIcon id={"downPDF" + row.ChaveNf} fontSize="large" />}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export const downloadXML = (cell, row) => {
  const isOD = row.Cnpj === "82640558000104" ? true : false;
  return (
    <div>
      {row.XmlNoS3 ? (
        <IconButtonLoader
          title="Download XML"
          size="small"
          onClick={(e) =>
            getFileInvoice(isOD, "xml", isOD ? row.NumeroNf : row.ChaveNf, e)
          }
          icon={<GetAppIcon id={"downXML" + row.ChaveNf} fontSize="large" />}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export const chaveNFFormatter = (chaveNfe) => {
  return (
    <Tooltip title="Copiar Chave NF">
      <IconButton
        size="small"
        onClick={() => {
          UtilsFncs.CopyToClipboard(chaveNfe);
        }}
      >
        <FileCopy fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

const baseField = {
  headerAlign: "center",
  csvFormatter: (cell) => cell || "",
};

export const sortableField = (field) => ({
  sort: true,
  sortCaret: () => {
    return null;
  },
  csvFormatter: (cell) => {
    return cell || "";
  },
  ...baseField,
  ...field,
});

export const columnTextField = (field) => ({
  csvFormatter: (cell) => {
    return cell || "";
  },
  align: "left",
  ...baseField,
  ...field,
});

export const columnDateField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;
  const {
    formatter: fieldFormatter,
    csvFormatter: fieldCsvFormatter,
    ...fieldRest
  } = field;

  const defaultFormatter = (cell) => {
    if (cell && typeof cell === "string") {
      if (cell.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(cell)) {
        if (!MaskAndValid.validateDate(cell)) return null;
        const newDateFormatter = `${cell.substring(8, 10)}/${cell.substring(
          5,
          7
        )}/${cell.substring(0, 4)}`;
        return newDateFormatter;
      }
    }
    return cell ? MaskAndValid.formattDateBR(cell) : null;
  };

  const defaultCsvFormatter = (cell) => {
    if (cell && typeof cell === "string") {
      if (cell.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(cell)) {
        if (!MaskAndValid.validateDate(cell)) return "";
        const newDateFormatter = `${cell.substring(8, 10)}/${cell.substring(
          5,
          7
        )}/${cell.substring(0, 4)}`;
        return newDateFormatter;
      }
    }
    return cell ? MaskAndValid.formattDateBR(cell) : "";
  };

  return {
    ...baseObj,
    ...fieldRest,
    align: "center",
    formatter: fieldFormatter ?? defaultFormatter,
    csvFormatter: fieldCsvFormatter ?? defaultCsvFormatter,
  };
};

export const columnCNPJCPFWithCopyField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    dataField: field.dataField.concat("copy"),
    align: "center",
    formatter: (cell, row) => {
      return row[field.dataField] ? (
        <>
          {MaskAndValid.maskCPNJCPF(row[field.dataField])}
          <IconButton
            style={{ marginLeft: 5, marginBottom: 1 }}
            title="Copiar"
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(
                MaskAndValid.maskCPNJCPF(row[field.dataField])
              );
            }}
          >
            <FileCopyIcon fontSize="large" />
          </IconButton>
        </>
      ) : null;
    },
    csvFormatter: (cell) => (cell ? MaskAndValid.maskCPNJCPF(cell) : ""),
  };
};

export const columnCNPJCPFField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "center",
    formatter: (cell) => (cell ? MaskAndValid.maskCPNJCPF(cell) : null),
    csvFormatter: (cell) => (cell ? MaskAndValid.maskCPNJCPF(cell) : ""),
  };
};

export const formatterWithCopy = (value) => {
  return value ? (
    <>
      {value}
      <IconButton
        style={{ marginLeft: 5, marginBottom: 1 }}
        title="Copiar"
        size="small"
        onClick={() => {
          UtilsFncs.CopyToClipboard(value);
        }}
      >
        <FileCopyIcon fontSize="large" />
      </IconButton>
    </>
  ) : null;
};

export const columnDateHourField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "center",
    formatter: (cell) =>
      cell
        ? !cell.includes("T00:00:00")
          ? MaskAndValid.formattDateHourBR(cell)
          : MaskAndValid.formattDateBR(cell)
        : null,
    csvFormatter: (cell) =>
      cell
        ? !cell.includes("T00:00:00")
          ? MaskAndValid.formattDateHourBR(cell)
          : MaskAndValid.formattDateBR(cell)
        : "",
  };
};

export const columnNumberField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    align: "center",
    ...field,
  };
};

export const columnBooleanField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "center",
    formatter: (params) => {
      return MaskAndValid.formatYesNo(params);
    },
    csvFormatter: (cell) => MaskAndValid.formatYesNo(cell),
  };
};

export const columnDecimalField = (field, isSortable, decimals = 1) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "right",
    formatter: (cell) => (cell ? MaskAndValid.maskPrice(cell, decimals) : null),
    csvFormatter: (cell) =>
      cell ? MaskAndValid.maskPrice(cell, decimals) : "",
  };
};

export const columnPriceField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    align: "right",
    formatter: (cell) => {
      return cell !== null ? "R$" + MaskAndValid.maskPrice(cell) : null;
    },
    csvFormatter: (cell) => (cell !== null ? MaskAndValid.maskPrice(cell) : ""),
    ...field,
  };
};

export const columnPhoneField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "left",
    formatter: (value) => {
      return value ? <PhoneText phone={value} showCopy showWhatsapp /> : null;
    },
  };
};

export const columnEmailField = (field, isSortable) => {
  const baseObj = isSortable ? sortableField() : baseField;

  return {
    ...baseObj,
    ...field,
    align: "left",
    formatter: (value) => {
      return value ? <EmailText email={value} showCopy showWhatsapp /> : null;
    },
  };
};
